import React from "react";
import { Table, Button, Flex } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import EditableCell from "../editableCell/EditableCell"; 

const TableCompetencies = (props) => {

    const columns = [
        {
            title: "Id",
            dataIndex: "cmp_id",
            key: "cmp_id",
            align: "center",
        },
        {
            title: "Competencia",
            dataIndex: "cmp_competence",
            key: "cmp_competence",
            editable: true,
        },
        {
            title: '',
            dataIndex: 'cmp_actions',
            key: 'cmp_actions',
            align: "center",
            fixed: "right",
            width: 60,
            render: (text, row, index) => {
                return <Flex gap="small" wrap>
                    <Button onClick={() => setCompetenceValuesToSee(row)} style={{ backgroundColor: "#293790", color: "white" }} icon={<EyeOutlined />} size={"large"} title='Ver competencia' />
                </Flex>
            }
        }
    ];

    const setCompetenceValuesToSee = (cmp) => {
        props.setCompetenceValuesToSee(cmp)
    }

    return (
        <Table
            className="custom-green-table"
            size="small"
            dataSource={props.data}
            columns={columns}
            pagination={{ pageSize: 10, position: ["bottomRight"] }}
            scroll={{ x: "max-content" }}
            components={{ body: { cell: EditableCell } }}
        />
    );
};

export default TableCompetencies;
